'use strict';

var util = require('../util/property-util');

module.exports = /*@ngInject*/ ["ProjectService", function (ProjectService) {

    var factory = {};

    /**
     * Given a list of trains, return an Object array of unique train types.
     * Fields: code (train type) and name (type to display).
     * @param trains
     * @returns {Array}
     */
    factory.getTrainTypeObjects = function (trains) {
        var collected = [];
        var types = [];

        // run over trains
        trains.forEach(function(train) {
            var type = train.type;

            // check current list.
            if (collected.indexOf(type) == -1) {
                // not yet found
                // -> push it on the collected array and create new TrainTypeObject.
                collected.push(type);

                var typeData = factory.createTrainTypeObject(type);
                types.push(typeData);
            }
        });

        return types;
    };

     /**
     * Given a list of trains, return an Object array of a pair of train type and its correspondinf display name.
     * @param trains
     * @returns {Array}
     */
    factory.getTrainTypeDisplayNameObjects = function (trains) {
       return trains.reduce((collected, train) => {
            if (train.type && !collected[train.type]) {
                collected[train.type] = {
                    displayName: train.displayTypeName || train.structure && train.structure.displayTypeName || train.type
                };
            }
            return collected;
        }, []);
    };


    /**
     * Creates a TrainTypeObject based on trainType.
     * If sameDisplayType is undefined or false,
     * the type will be parsed to get a display string.
     *
     * @param trainType
     * @param sameDisplayType
     * @returns created TrainTypeObject.
     */
    factory.createTrainTypeObject = function(trainType,sameDisplayType) {

        var typeData = {};
        typeData.code = trainType;
        if (!util.isDefined(sameDisplayType) || !sameDisplayType) {
            typeData.name = factory.makeDisplayTrainType(trainType);
        } else {
            typeData.name = trainType;
        }

        return typeData;
    };

    /**
     * Given an array of TrainTypeObjects, return the TrainTypeObject containing the trainType string.
     * Returns null if it's not in the list.
     * @param trainTypeObjects
     * @param trainType
     * @returns TrainTypeObject if it exists.
     */
    factory.getTrainType = function(trainTypeObjects, trainType) {
        var trainTypeObject = null;

        trainTypeObjects.some(function(trainTypeData) {
            if (trainTypeData.code == trainType) {
                trainTypeObject = trainTypeData;
                return true;
            }

            return false;
        });

        return trainTypeObject;
    };


    /**
     * Given a Train, the function will return true/false, if the train type is in the
     * trainTypeObjects list.
     * @param train
     * @param trainTypeObjects
     * @returns true/false
     */
    factory.filterTrainByTypesFilter = function (train, trainTypeObjects) {
        if (!util.isDefined(trainTypeObjects) || (trainTypeObjects.length == 0)) {
            return true;
        } else {
            var found = false;
            trainTypeObjects.some(function(trainTypeObject){
                if (trainTypeObject.code == train.type) {
                    found = true;
                    return true;
                } else {
                    return false;
                }
            });

            return found;
        }
    };


    /**
     * Given a Train, the function will return true/false, if the train type
     * is the same as the trainTypeObject.
     * @param train
     * @param trainTypeObject
     * @returns true/false
     */
    factory.filterTrainByTypeFilter = function (train, trainTypeObject) {
        if (!util.isDefined(trainTypeObject)) {
            return true;
        } else {
            return trainTypeObject.code == train.type;
        }
    };

    /**
     * @returns the inner part of the train type to display in menu.
     * The format for a type is:
     * - projectname-type-tech. E.g. sncf-dasye-mar3 -> dasye.
     * - projectname-tech. E.g. smart-mar3 -> smart
     */
    factory.makeDisplayTrainType = function (trainType) {
        var splits = trainType && trainType.split('-');
        var length = splits ? splits.length : 0;

        if (length > 0) {
            if (length <= 2) {
                return splits[0];
            } else {
                var currentProjectId = ProjectService.getSelectedProjectId();
                if (length === 3) {
                    return currentProjectId === 0 ? splits[0] + '-' + splits[1] : splits[1];
                } else {
                    return currentProjectId === 0 ? splits[0] + '-' + splits[1] + '-' + splits[2] : splits[1] + '-' + splits[2];
                }
            }
        } else {
            return null;
        }


    };

    return factory;

}];
